import { Outlet } from 'react-router-dom';
import Navbar from '../navbar';
import BgImg from '@/assets/bg_cover.svg';

const Layout = (): JSX.Element => {
  return (
    <div
      className="bg-cover bg-top bg-no-repeat"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Navbar />
      <Outlet />
    </div>
  );
};

export default Layout;
